import React from "react";
import Button from "components/atoms/button";
import { FiSend } from "react-icons/fi";
import { ImArrowUpRight2 } from "react-icons/im";
import "./about.scss";
import ME from "assets/images/me.jpg";

export const About = () => {
  return (
    <section id="about" className="about">
      <div className="row row-center">
        <div className="col-md-6 col-sm-6 animate__animated animate__fadeInDown animate__fast">
          <div className="about__title animate__animated animate__fadeInDown">
            <h1 className="about__title__bold">Experienced</h1>
            <h1 className="about__title__normal">developer you need</h1>
          </div>
          <div className="about__msg animate__animated animate__fadeInDown">
            <hr />
            <p>
              Hi! This is Adolfo, a full-stack developer creating fast and
              stable softwares across the world.
            </p>
          </div>
          <div className="d-flex about__actions animate__animated animate__fadeInDown animate__faster">
            <Button
              icon={<FiSend />}
              text="Let's talk!"
              classNames="primary me-1"
            />

            <Button
              icon={<ImArrowUpRight2 />}
              text="Portfolio"
              classNames="white ms-1"
            />
          </div>
        </div>
        <div className="col-md-6 col-sm-6 center animate__animated animate__fadeInDown animate__faster">
          <div className="phrase animate__animated animate__fadeInDown">
            <h4>"People ignore software that ignores people"</h4>
          </div>

          <div className="profile">
            <img className="image" src={ME} alt="" />
          </div>
        </div>
      </div>

      <div className="scroll__down">
        <h6>Scroll down</h6>
      </div>
    </section>
  );
};
